import { render, staticRenderFns } from "./successDialog.vue?vue&type=template&id=5dac4a58&scoped=true"
import script from "./successDialog.vue?vue&type=script&lang=js"
export * from "./successDialog.vue?vue&type=script&lang=js"
import style0 from "./successDialog.vue?vue&type=style&index=0&id=5dac4a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dac4a58",
  null
  
)

export default component.exports